// Coarse user-agent check for "is this a phone/tablet browser?". Used to swap UI that
// only makes sense on a desktop (e.g. a QR code you scan with a *different* device) for a
// mobile-appropriate alternative. This same regex is also inlined in a couple of
// entrypoints (country_region.ts, trails.ts) — this is the shared, testable home for it.
export function isMobileDevice(): boolean {
  return /Mobi|Android|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
    navigator.userAgent
  );
}
